


















import {Vue, Component, Prop, Ref} from 'vue-property-decorator'
import {SceneShot} from '@/store/shots'
import NGL from '@/components/NGL.vue';
import {shotStore} from '@/store'
import {SceneTemplate} from '@/store/templates'
import {CameraTrack} from '@/store/camera-tracks'

@Component({
  name: 'SceneShotEditor',
  components: {NGL}
})
export default class SceneShotEditor extends Vue {
  @Prop() shot!: SceneShot
  @Prop() expanded!: boolean
  @Ref() nglViewer!: any

  get molecules() {
    return this.shot.components.reduce((map, c) => {
      map[c.id] = c.molecule
      return map
    }, {} as {[index: string]: string})
  }

  async reloadSceneTemplate(template: SceneTemplate) {
    await shotStore.changeSceneShotTemplate({shot: this.shot, selected: template})
    await (this.$refs.nglViewer as any).loadBackgroundScene(false, false)
  }

  async reloadSceneCameraTrack(camTrack: CameraTrack) {
    await (this.$refs.nglViewer as any).importCameraAnimation(camTrack)
  }
}
